// removed by extract-text-webpack-plugin
module.exports = {"editor":"cms__index__editor"};


//////////////////
// WEBPACK FOOTER
// ./components/Widgets/MarkdownControlElements/VisualEditor/index.css
// module id = 560
// module chunks = 0